// extracted by mini-css-extract-plugin
export default {"uploader":"uploader_uploader__+fNNz","uploader__icon":"uploader_uploader__icon__TlpYA","uploader__img":"uploader_uploader__img__I1EeJ","trash":"uploader_trash__Wp735"};